"use client";

;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { INTEGRATIONS_LOCAL_STORAGE_KEYS } from "@/components/settings/data-providers/constants";
import { Button } from "@/components/ui/button";
import { setLocalStorageItem } from "@/lib/browser-storage/localStorage";
import { queryFetcher } from "@/queries/config/query-fetcher";
type PodiumAuthUrlResponse = {
  authUrl?: string;
};
export function PodiumScopeUpgradeAccess({
  workspaceId
}: {
  workspaceId: string;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleUpgradeAccess = async () => {
    if (!workspaceId || isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    try {
      const result = await queryFetcher<PodiumAuthUrlResponse>(`/api/workspaces/${workspaceId}/data-provider/podium?flow=scope_upgrade`, {
        method: "GET"
      });
      if (!result.authUrl) {
        throw new Error("Failed to generate the Podium authorization URL");
      }
      setLocalStorageItem(INTEGRATIONS_LOCAL_STORAGE_KEYS.PODIUM, window.location.pathname);
      window.location.assign(result.authUrl);
    } catch {
      toast.error("Failed to start Podium access upgrade");
    } finally {
      setIsSubmitting(false);
    }
  };
  return <Button className="hidden h-6 border-border bg-transparent px-2 text-xs shadow-none hover:bg-white @[18rem]/provider-card:inline-flex" disabled={isSubmitting} onClick={handleUpgradeAccess} variant="ghost">
			{isSubmitting ? <Loader2 className="animate-spin" /> : null}
			{isSubmitting ? "Upgrading..." : "Upgrade access"}
		</Button>;
}